/* eslint-disable camelcase */

import OffersManagementMapper from './mappers';

export const onSetOfferManagementContentData = (data, callback) => {
  const content = OffersManagementMapper.mapPrismicDataToContent(data);

  callback(content);
};

export const onSetOfferManagementOffersData = ({ offers, role }, callback) => {
  const mappedOffers = OffersManagementMapper.mapListingsOffers(offers, role);

  callback(mappedOffers);
};
